import { render } from "./cares.vue?vue&type=template&id=36f69721&scoped=true"
import script from "./cares.vue?vue&type=script&lang=js"
export * from "./cares.vue?vue&type=script&lang=js"

import "./cares.vue?vue&type=style&index=0&id=36f69721&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f69721"]])

export default __exports__